import React, { useState, useEffect } from "react";
import { useQuery } from "react-query";
import { useForm } from "react-hook-form";
// import RadarChrt from "../chart/RadarChrt";
import PolarAreaChrt from "../chart/PolarAreaChrt";
import {
  Card,
  Table,
  Button,
  Form,
  InputGroup,
  Modal,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { toast } from "react-toastify";
import {
  getHousingData,
  deleteHousingData,
  getHousingPhoto,
  getPictures,
} from "../../services/housingService";
import { useAuth } from "../../contexts/AuthContext";
import HousingForm from "./HousingForm";
// import { useDropzone } from "react-dropzone";
// import { compressImage } from "../../utils/image-compression-and-integration";
import PictureForm from "./PictureForm";
import PaginationSearch from "../pagination/PaginationSearch";
import {
  getDistrict,
  getSubdistrictByDistrict,
} from "../../services/commonService";

const HousingData = () => {
  const { user } = useAuth();
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(""); // 🔥 debounce state
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [showForm, setShowForm] = useState(false);
  const [selectedHousing, setSelectedHousing] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [pictures, setPictures] = useState([]);
  const [showPictures, setShowPictures] = useState(false);
  const [currentHousingId, setCurrentHousingId] = useState(null);
  const isMobile = window.innerWidth < 768;
  const [pendingPhotos, setPendingPhotos] = useState([]);
  // const [manualMode, setManualMode] = useState(false); // 🔥 toggle mode
  // const [setHousingData] = useState(null);
  const [showRadar, setShowRadar] = useState(false);
  const [districts, setDistricts] = useState([]);
  const [subdistricts, setSubdistricts] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedSubdistrict, setSelectedSubdistrict] = useState("");

  const {
    // register,
    // handleSubmit,
    // formState: { errors },
    setValue,
    // getValues,
  } = useForm();

  // Effect pertama: ambil data districts saat load awal
  useEffect(() => {
    const fetchDistricts = async () => {
      try {
        const data = await getDistrict();
        setDistricts(data.data);
      } catch (error) {
        console.error("Gagal ambil district:", error);
      }
    };
    fetchDistricts();
  }, []);

  // mapping Kecamatan
  const districtMap = Object.fromEntries(districts.map((d) => [d.id, d.name]));

  // Effect kedua: ambil subdistrict tiap kali district berubah
  useEffect(() => {
    const fetchSubdistricts = async () => {
      if (selectedDistrict) {
        // console.log("DISTRICTS: ", districts);
        // console.log("SELECTEDDISTRICT: ", selectedDistrict);

        try {
          const data = await getSubdistrictByDistrict(selectedDistrict);
          setSubdistricts(data.data);
          setSelectedSubdistrict("");
        } catch (error) {
          console.error("Gagal ambil subdistrict:", error);
        }
      } else {
        setSubdistricts([]);
        // setValue("subdistrict_id", "");
        setSelectedSubdistrict("");
      }
    };
    fetchSubdistricts();
  }, [districts, selectedDistrict, setValue]);

  // 🔥 debounce effect
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
      setCurrentPage(1); // reset ke halaman 1 tiap kali search baru
    }, 500);

    return () => clearTimeout(handler);
  }, [searchTerm]);

  const handleShowPictures = async (housingId) => {
    try {
      const res = await getPictures(housingId);
      let picsWithBlob = [];
      if (res.data && res.data.length > 0) {
        picsWithBlob = await Promise.all(
          res.data.map(async (pic) => {
            const blobUrl = await getHousingPhoto(pic.file_name);
            return { ...pic, blobUrl };
          })
        );
      }
      setPictures(picsWithBlob); // kalau kosong tetap []
      setCurrentHousingId(housingId);
      setShowPictures(true); // ✅ modal tetap dibuka walau kosong
    } catch (err) {
      console.error("Error handleShowPictures:", err);
      toast.error(
        "Gagal mengambil foto, tapi Anda masih bisa menambah foto baru."
      );
      setPictures([]);
      setCurrentHousingId(housingId);
      setShowPictures(true);
    }
  };

  // 🧹 Cleanup blob URL saat modal ditutup
  const handleClosePictures = () => {
    pictures.forEach((pic) => {
      if (pic.blobUrl) {
        URL.revokeObjectURL(pic.blobUrl);
      }
    });
    setPictures([]);
    setShowPictures(false);
    setCurrentHousingId(null);
  };

  // 🧹 Cleanup otomatis saat komponen unmount
  useEffect(() => {
    return () => {
      pictures.forEach((pic) => {
        if (pic.blobUrl) {
          URL.revokeObjectURL(pic.blobUrl);
        }
      });
    };
  }, [pictures]);

  // -----------------------------
  // React Query mode
  // -----------------------------
  const {
    data: housingData,
    isLoading,
    error,
    refetch,
  } = useQuery(
    [
      "housingData",
      currentPage,
      debouncedSearchTerm,
      limit,
      selectedDistrict,
      selectedSubdistrict,
    ],
    () =>
      getHousingData({
        page: currentPage,
        search: debouncedSearchTerm,
        limit: limit,
        selectedDistrict: selectedDistrict,
        selectedSubdistrict: selectedSubdistrict,
      }),
    {
      keepPreviousData: true,
      // enabled: !manualMode,
      // onSuccess: (data) => {
      //   if (!manualMode) setHousingData(data);
      // },
      onError: (err) => {
        toast.error("Gagal ambil data (React Query)");
        console.error(err);
      },
    }
  );

  const handleOpenRadar = (housing) => {
    // console.log("EDIT housing: ", housing);
    setSelectedHousing(housing);
    setCurrentHousingId(housing.housing_id);
    setShowRadar(true);
  };

  const handleEdit = (housing) => {
    setSelectedHousing(housing);
    setCurrentHousingId(housing.housing_id);
    // try {
    //   const pics = getPictures(housing.housing_id);
    //   const withBlobUrl = Promise.all(
    //     pics.map(async (pic) => ({
    //       ...pic,
    //       blobUrl: getHousingPhoto(pic.filename),
    //     }))
    //   );
    //   setPictures(withBlobUrl);
    // } catch (err) {
    //   console.error("Gagal ambil foto housing:", err);
    //   setPictures([]);
    // }
    setShowForm(true);
  };

  const handleDelete = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    try {
      await deleteHousingData(deleteId);
      toast.success("Data berhasil dihapus");
      refetch();
      setShowDeleteModal(false);
    } catch (error) {
      toast.error("Gagal menghapus data");
    }
  };

  const handleFormClose = () => {
    setShowForm(false);
    // Tangani gambar setelah form ditutup
    pictures.forEach((pic) => {
      if (pic.blobUrl) {
        URL.revokeObjectURL(pic.blobUrl);
      }
    });
    // setPictures([]);
    // setShowPictures(false);
    setCurrentHousingId(null);
    setSelectedHousing(null);
  };

  const handleFormSuccess = () => {
    refetch();
    handleFormClose();
  };

  if (isLoading) return <div className="loading-spinner">Loading...</div>;
  if (error) return <div className="error-message">Error: {error.message}</div>;

  return (
    <div className="container-fluid">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="fw-bold">Data Housing</h2>
        {user?.role === "admin" ? (
        // {user?.role === "admin" || user?.role === "pengguna" ? (
          <Button variant="primary" onClick={() => setShowForm(true)}>
            <i className="fas fa-plus me-2"></i>
            Tambah Data
          </Button>
        ) : null}
        {/* Toggle mode */}
        {/* <Button
          variant={manualMode ? "warning" : "success"}
          onClick={() => setManualMode(!manualMode)}
        >
          {manualMode ? "Switch to React Query Mode" : "Switch to Manual Mode"}
        </Button> */}
      </div>

      <Card>
        <Card.Body>
          <div className="row mb-3">
            <div className="row align-items-center">
              <div className="col-md-4 mb-3">
                <Form.Group>
                  <Form.Label>Kecamatan</Form.Label>
                  <Form.Select
                    value={selectedDistrict}
                    onChange={(e) => setSelectedDistrict(e.target.value)}
                  >
                    <option value="">SEMUA</option>
                    {districts.map((d) => (
                      <option key={d.id} value={d.id}>
                        {d.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </div>

              <div className="col-md-4 mb-3">
                <Form.Group>
                  <Form.Label>Desa/Kelurahan</Form.Label>
                  <Form.Select
                    value={selectedSubdistrict}
                    onChange={(e) => setSelectedSubdistrict(e.target.value)}
                    disabled={!selectedDistrict}
                  >
                    <option value="">
                      {selectedDistrict
                        ? "SE-KECAMATAN " + districtMap[selectedDistrict]
                        : "SEMUA"}
                    </option>
                    {subdistricts.map((s) => (
                      <option key={s.id} value={s.id}>
                        {s.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </div>

              <div className="col-md-4">
                <InputGroup>
                  <InputGroup.Text>
                    <i className="fas fa-search"></i>
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="Cari data..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </InputGroup>
              </div>
            </div>
          </div>

          <Table responsive striped hover>
            <thead>
              <tr>
                <th>No</th>
                {/* <th>Id</th> */}
                <th>Nama Kepala Keluarga</th>
                <th>Alamat</th>
                <th>Desa</th>
                <th>Kecamatan</th>
                <th>Informasi</th>
                <th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              {housingData?.data?.map((housing, index) => (
                <tr key={housing.housing_id}>
                  <td>{(housingData.pagination.page - 1) * parseInt(limit, 10) + index + 1}</td>
                  {/* <td>{housing.housing_id}</td> */}
                  <td>{housing.household_head_name}</td>
                  <td>{housing.address}</td>
                  <td>{housing.sub_district_name}</td>
                  <td>{housing.district_name}</td>
                  {/* NON AKTIFKAN */}
                  <td>
                    {/* Tombol Grafik */}
                     <OverlayTrigger 
                      placement="top"
                       overlay={ 
                        <Tooltip
                           id={`tooltip-radar-chart-${housing.housing_id}`} 
                         > 
                           Lihat Grafik 
                         </Tooltip> 
                       } 
                     > 
                       <Button 
                         size="sm" 
                         variant="secondary" 
                         className="me-3 action-btn" 
                         onClick={() => handleOpenRadar(housing)} 
                       > 
                         📊 
                         <i className="fas fa-radar-chart"></i> 
                       </Button> 
                     </OverlayTrigger> 
                   </td> 
                  <td>
                    <div className="group-this-items">
                       {/* Tombol Foto  */}
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id={`tooltip-foto-${housing.housing_id}`}>
                            Lihat Foto
                          </Tooltip>
                        }
                      >
                        <Button
                          size="sm"
                          variant="secondary"
                          className="me-3 action-btn"
                          onClick={() => handleShowPictures(housing.housing_id)}
                        >
                          <i className="fas fa-image"></i>
                        </Button>
                      </OverlayTrigger>

                      {/* Tombol Edit */}
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id={`tooltip-edit-${housing.housing_id}`}>
                            Edit Data
                          </Tooltip>
                        }
                      >
                        <Button
                          size="sm"
                          variant="info"
                          className="me-3 action-btn"
                          onClick={() => handleEdit(housing)}
                        >
                          <i className="fas fa-edit"></i>
                        </Button>
                      </OverlayTrigger>

                      {/* Tombol Hapus */}
                      {/* {(user?.role === "admin" ) && ( */}
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id={`tooltip-hapus-${housing.housing_id}`}>
                              Hapus Data
                            </Tooltip>
                          }
                        >
                          <Button
                            size="sm"
                            variant="danger"
                            className="me-3 action-btn"
                            onClick={() => handleDelete(housing.housing_id)}
                            disabled={user?.role !== "admin"}
                          >
                            <i className="fas fa-trash"></i>
                          </Button>
                        </OverlayTrigger>
                      {/* )} */}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          {/* Pagination */}
          {housingData?.pagination && (
            <div className="mt-2">
              <PaginationSearch
                pagination={housingData.pagination}
                currentPage={housingData.pagination.page}
                setCurrentPage={setCurrentPage}
                limit={limit}
                setLimit={setLimit}
              />
            </div>
          )}
        </Card.Body>
      </Card>

      {/* Housing Form Modal */}
      <Modal show={showForm} onHide={handleFormClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            {selectedHousing ? "Edit Data Housing" : "Tambah Data Housing"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <HousingForm
            housing={selectedHousing}
            onSuccess={handleFormSuccess}
            onCancel={handleFormClose}
            // pictures={pictures}
            // setPictures={setPictures}
            housingId={currentHousingId}
            // pendingPhotos={pendingPhotos}
            // setPendingPhotos={setPendingPhotos}
            isMobile={isMobile}
            user={user}
          />
        </Modal.Body>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Konfirmasi Hapus</Modal.Title>
        </Modal.Header>
        <Modal.Body>Apakah Anda yakin ingin menghapus data ini?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Batal
          </Button>
          <Button variant="danger" onClick={confirmDelete}>
            Hapus
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal PictureForm */}
      <PictureForm
        show={showPictures}
        onClose={handleClosePictures}
        pictures={pictures}
        setPictures={setPictures}
        housingId={currentHousingId}
        pendingPhotos={pendingPhotos}
        setPendingPhotos={setPendingPhotos}
        isMobile={isMobile}
      />

      {/* Modal Radar */}
      <PolarAreaChrt
        show={showRadar}
        onHide={() => setShowRadar(false)}
        assessment={selectedHousing}
        rumah={currentHousingId}
      />
    </div>
  );
};

export default HousingData;
